module.exports = __webpack_public_path__ + "static/media/wallet.ff4780a2.svg";